var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedditColor = function SvgRedditColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4500",
    d: "M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M28.16 21.607a4.184 4.184 0 1 0 0-8.369 4.184 4.184 0 0 0 0 8.369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M7.84 21.607a4.184 4.184 0 1 0 0-8.369 4.184 4.184 0 0 0 0 8.369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M18.013 29.961c6.592 0 11.937-4.01 11.937-8.956s-5.345-8.956-11.937-8.956c-6.593 0-11.937 4.01-11.937 8.956s5.344 8.956 11.937 8.956"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842123",
    d: "M14.473 20.137c-.07 1.512-1.078 2.071-2.253 2.071s-2.071-.783-2.001-2.295c.07-1.51 1.077-2.518 2.253-2.518 1.175 0 2.07 1.231 2 2.742m11.307-.224c.07 1.512-.826 2.295-2.001 2.295-1.176 0-2.183-.545-2.253-2.07-.07-1.512.825-2.744 2-2.744s2.184.994 2.254 2.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M21.541 20.279c.07 1.413 1.008 1.931 2.1 1.931 1.09 0 1.93-.77 1.874-2.197-.07-1.413-1.007-2.35-2.099-2.35-1.091 0-1.945 1.189-1.875 2.616"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M14.474 20.279c-.07 1.413-1.008 1.931-2.099 1.931s-1.931-.77-1.861-2.197c.07-1.413 1.007-2.35 2.099-2.35 1.091 0 1.931 1.189 1.861 2.616"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBCFDA",
    d: "M18.015 23.217c-1.484 0-2.897.07-4.212.196-.224.028-.364.252-.28.447.727 1.722 2.463 2.94 4.492 2.94s3.75-1.204 4.492-2.94a.323.323 0 0 0-.28-.447 44 44 0 0 0-4.212-.196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.014 23.553c-1.483 0-2.896.07-4.198.21a.34.34 0 0 0-.28.461 4.85 4.85 0 0 0 4.478 2.981 4.85 4.85 0 0 0 4.478-2.98.34.34 0 0 0-.28-.462 40 40 0 0 0-4.198-.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M18.015 23.37c-1.456 0-2.841.07-4.129.195-.223.028-.363.252-.28.448.728 1.721 2.422 2.939 4.409 2.939a4.77 4.77 0 0 0 4.408-2.94.323.323 0 0 0-.28-.447 48 48 0 0 0-4.128-.196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M24.549 10.846a2.967 2.967 0 1 0 0-5.934 2.967 2.967 0 0 0 0 5.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M17.972 12.426c-.35 0-.644-.154-.644-.378a4.814 4.814 0 0 1 4.814-4.814c.35 0 .644.294.644.644s-.294.644-.644.644a3.53 3.53 0 0 0-3.526 3.526c0 .238-.294.378-.644.378"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6101",
    d: "M13.704 20.978c0 .546-.587.798-1.301.798s-1.301-.252-1.301-.798.587-.994 1.301-.994 1.301.434 1.301.994m11.223 0c0 .546-.587.798-1.3.798-.715 0-1.302-.252-1.302-.798s.587-.994 1.301-.994 1.301.434 1.301.994"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC49C",
    d: "M13.298 19.48c.255 0 .461-.225.461-.504 0-.278-.206-.503-.461-.503s-.462.225-.462.503c0 .279.207.504.462.504M24.339 19.48c.255 0 .462-.225.462-.504 0-.278-.207-.503-.462-.503s-.462.225-.462.503c0 .279.207.504.462.504"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.38254 0 0 7.31243 28.218 15.163)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F9FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EDF3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DEE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D8E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CCD8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C8D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CCD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8DBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EDE3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFEBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.38254 0 0 7.31243 7.91 15.163)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F9FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EDF3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DEE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D8E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CCD8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C8D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CCD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8DBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EDE3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFEBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.2851 0 0 17.7533 18.327 13.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F9FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EDF3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DEE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D8E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CCD8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C8D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CCD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8DBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EDE3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFEBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.11257 0 0 -3.10143 23.218 21.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FC4301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F43F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#E53812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4301F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.11257 0 0 3.10143 12.71 21.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FC4301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F43F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#E53812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4301F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.44925 0 0 4.91333 18.052 27.387)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0E1C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#030708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(24.62 4.885)scale(6.53897)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F9FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EDF3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DEE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D8E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CCD8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C8D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CCD6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8DBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#EDE3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFEBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(21.896 12.013)scale(5.3597)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A9299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7A9299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#172E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#172E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172E35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgRedditColor;